import React, {useMemo, useState} from 'react';
import MenuForm from '@components/Menu/MenuForm';
import Layout from "@hoc/layouts/Layout";
import Checkout from "@components/Checkout/Checkout";
import ServiceUnavailable from "@components/Menu/ServiceUnavailable";

const Order = ({
                 userLocation,
                 canAccess,
                 data,
                 categories,
                 table,
                 supportedPaymentMethods,
                 onSearch,
                 selectedCategory,
                 onCategorySelect,
                 viewMode
               }) => {

  const categoryRefs = {};

  const [activeForm, setActiveForm] = useState('menu');
  const [selectedProducts, setSelectedProducts] = useState([]);

  const total = useMemo(
    () =>
      selectedProducts
        ? selectedProducts.map((p) => p.qty * p.price).reduce((prev, curr) => prev + curr, 0)
        : 0,
    [selectedProducts]
  );

  const scrollToCategory = async (category) => {
    const tabId = `tab-${category.id}`;
    const tabElement = document.getElementById(tabId);

    if (categoryRefs[category.id] && tabElement) {
      const headerHeight = 256;
      const scrollPosition = categoryRefs[category.id].offsetTop - headerHeight;

      const windowScrollPromise = new Promise((resolve) => {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });

        setTimeout(resolve, 800);
      });

      await windowScrollPromise;

      tabElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  };

  return (
    canAccess ?
      activeForm === 'menu' ?
        <Layout menu={categories}
                businessData={data}
                onSearch={onSearch}
                table={table}
                selectedCategory={selectedCategory}
                onSelect={onCategorySelect}
                scroll={scrollToCategory}
                activeForm={activeForm}>
          <MenuForm viewMode={viewMode}
                    menu={categories}
                    categoryRefs={categoryRefs}
                    setActiveForm={setActiveForm}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    total={total}/>
        </Layout> :
        <Checkout userLocation={userLocation}
                  businessName={data?.pageName}
                  businessId={data?.id}
                  table={table}
                  selectedProducts={selectedProducts}
                  setSelectedProducts={setSelectedProducts}
                  total={total}
                  paymentMethods={supportedPaymentMethods}
                  setActiveForm={setActiveForm}/>
      : <ServiceUnavailable/>
  );
};

export default Order;
